import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateVenue($companyId: ID!, $attributes: VenueAttributes!) {
    createVenue(companyId: $companyId, attributes: $attributes) {
       venue {
        id
        ...CreatedVenue
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedVenue on Venue {
    id
    name
    address
  }
`
